import { useState } from "react";
import { Link, useParams } from 'react-router-dom';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { Checkbox, Input } from "components/__new/common/form";
import useBackButton from "hooks/useBackButton";
import { BackButtonPage } from "components/__new/common/BackButton";
import TabSettings from "components/__new/common/TabSettings";


const Form = () => {
    const {id} = useParams()
    const {goBack} = useBackButton();


    const page = (id ? "Edit" : "Create");
    const [form, setForm] = useState({
        email: "",
    })


    return ( 
        <div>


            <DynamicHeadTag
                headerText="Custom Role | Team Management | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />


            {/* <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 border-b">
                <SettingsTab />
            </div> */}


            <div className="mt-6 lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage />
                        {page} Custom Role
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3">
                    {/* 
                    <button type="submit" className="btn btn-ep-primary md:btn-lg">
                        {page} custom role
                    </button>
                     */}
                    <Link to="/settings/team-management/roles/create/permissions" className="btn btn-ep-primary md:btn-lg">
                        {page} custom role
                    </Link>
                    <button onClick={goBack} className="btn btn-transparent-primary md:btn-lg">
                        Cancel
                    </button>
                </div>
            </div>


            <div className="mt-6 box">
                <div className="border-b">
                    <TabSettings options={[
                        {
                            title: <span>Role Details</span>,
                            type: "link",
                            url: "/settings/team-management/roles/create/details",
                        },
                        {
                            title: <span>Role Permissons</span>,
                            type: "link",
                            url: "/settings/team-management/roles/create/permissions",
                        },
                    ]} />
                </div>

                <div className="mt-6 max-w-md">
                    <Input type="text" label="Name of Role" placeholder="Name of Role" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />

                    <div className="form-group">
                        <label>
                            Description of Role
                        </label>
                        <div className="relative">
                            <textarea style={{resize: "none"}} className="h-28 form-input-textarea" placeholder="Input description of role"></textarea>
                        </div>
                    </div>

                    <div>
                        <div className="text-ep-primary font-medium">
                            Permissions
                        </div>

                        <div className="mt-3">
                            <Checkbox
                                type="radio"
                                label={<div className="text-sm">Full access to all features of the Business Admin</div>}
                            />
                        </div>

                        <div className="mt-3">
                            <Checkbox
                                type="radio"
                                checked={true}
                                label={<div className="text-sm">Configure access of the role (Custom Access)</div>}
                            />
                        </div>
                    </div>


                    <div className="h-10"></div>
                </div>
            </div>




        </div>
    )
}


export default Form;